import { BrowserRouter, Routes, Route } from "react-router-dom";
import Player from "./Player";
import DemoPlayer from "./DemoPlayer";
import { AuthProvider } from "../shared/auth/AuthContext";

function PlayerApp() {
  return (
    <BrowserRouter basename="/player">
      <Routes>
        <Route path="/game/:gameName/demo/:version" element={<DemoPlayer />} />
        <Route path="/game/:gameName/demo" element={<DemoPlayer />} />
        <Route
          path="/:matchId"
          element={
            <AuthProvider>
              <Player />
            </AuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default PlayerApp;
